import { Card, Form } from "react-bootstrap";

interface MapDataSelectorProps {
  selectedMetric: string;
  onMetricChange: (metric: string) => void;
}

// This component allows users to select which metric to visualize on the map
export default function MapDataSelector({
  selectedMetric,
  onMetricChange,
}: MapDataSelectorProps) {
  // Get available metrics from the same source as GraphsContainer
  const availableMetrics = createMetricsArray();

  const handleMetricChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onMetricChange(event.target.value);
  };

  return (
    <Card className="bg-dark text-white mb-4">
      <Card.Header>
        <h5 className="mb-0">Data Visualization</h5>
      </Card.Header>
      <Card.Body>
        <p className="text-muted mb-3">Select data to visualize on the map:</p>
        
        <Form>
          {availableMetrics.map((metric) => (
            <Form.Check
              key={metric.id}
              type="radio"
              id={`metric-${metric.id}`}
              label={metric.name}
              value={metric.id}
              checked={selectedMetric === metric.id}
              onChange={handleMetricChange}
              className="mb-2"
            />
          ))}
        </Form>
        
        <div className="mt-4">
          <h6>About this visualization</h6>
          <p className="text-muted small">
            The map shows the GPS track with colors representing the selected data.
            Different colors indicate different value ranges as shown in the legend.
          </p>
        </div>
      </Card.Body>
    </Card>
  );
}

// Create an array of available metrics for visualization
// This should match the metrics available in GraphsContainer
export function createMetricsArray() {
  return [
    {
      id: "apparentWindSpeedMagnitude_ms",
      name: "Apparent Wind Speed (m/s)",
      description: "Apparent wind speed in meters per second",
      unit: "m/s",
    },
    // {
    //   id: "ambientWindSpeedMagnitude_ms",
    //   name: "Ambient Wind Speed (m/s)",
    //   description: "Ambient wind speed in meters per second",
    //   unit: "m/s",
    // },
    {
      id: "trajectorySpeed_ms",
      name: "Movement Speed (m/s)",
      description: "Movement speed in meters per second",
      unit: "m/s",
    },
    {
      id: "temp",
      name: "Temperature",
      description: "Temperature in degrees Celsius",
      unit: "°C",
    },
    {
      id: "hum",
      name: "Humidity",
      description: "Relative humidity percentage",
      unit: "%",
    },
    {
      id: "motionPitchAngleS_rad",
      name: "Pitch Angle (°)",
      description: "Pitch angle in degrees",
      unit: "°",
    },
    {
      id: "motionRollAngleS_rad",
      name: "Roll Angle (°)",
      description: "Roll angle in degrees",
      unit: "°",
    },
    {
      id: "apparentWindPitchAngleOfAttack_rad",
      name: "Apparent Wind Pitch Angle (°)",
      description: "Apparent wind pitch angle in degrees",
      unit: "°",
    },
    {
      id: "apparentWindYawAngleOfAttack_rad",
      name: "Apparent Wind Yaw Angle (°)",
      description: "Apparent wind yaw angle in degrees",
      unit: "°",
    }
  ];
}
